import CircleComponent from './Circle.vue';
export const Circle = CircleComponent;
export default Circle;
